export type PlatformStatus =
  | "SUBMITTED"
  | "UNDER_REVIEW"
  | "APPROVED"
  | "DECLINED"
  | "CONVERTED"
  | "PENDING"
  | "SUPERSEDED"
  | "PENDING_ACTIVATION"
  | "ACTIVE"
  | "INACTIVE"
  | "INVITED"
  | "EXPIRED"
  | "REVOKED"
  | "ACCEPTED"
  | "FAILED"
  | "RUNNING"
  | "COMPLETED"
  | "CANCELLED";

type PlatformStatusBadgeProps = {
  status: PlatformStatus;
};

const statusStyles: Record<
  PlatformStatus,
  {
    label: string;
    className: string;
  }
> = {
  SUBMITTED: {
    label: "Submitted",
    className:
      "border-sky-200 bg-sky-50 text-sky-700",
  },
  UNDER_REVIEW: {
    label: "Under Review",
    className:
      "border-amber-200 bg-amber-50 text-amber-700",
  },
  APPROVED: {
    label: "Approved",
    className:
      "border-emerald-200 bg-emerald-50 text-emerald-700",
  },
  DECLINED: {
    label: "Declined",
    className:
      "border-rose-200 bg-rose-50 text-rose-700",
  },
  CONVERTED: {
    label: "Converted",
    className:
      "border-indigo-200 bg-indigo-50 text-indigo-700",
  },
  PENDING: {
    label: "Pending",
    className:
      "border-amber-200 bg-amber-50 text-amber-700",
  },
  SUPERSEDED: {
    label: "Superseded",
    className:
      "border-slate-200 bg-slate-100 text-slate-600",
  },
  PENDING_ACTIVATION: {
    label: "Pending Activation",
    className:
      "border-amber-200 bg-amber-50 text-amber-700",
  },
  ACTIVE: {
    label: "Active",
    className:
      "border-emerald-200 bg-emerald-50 text-emerald-700",
  },
  INACTIVE: {
    label: "Inactive",
    className:
      "border-slate-200 bg-slate-100 text-slate-600",
  },
  INVITED: {
    label: "Invited",
    className:
      "border-violet-200 bg-violet-50 text-violet-700",
  },
  EXPIRED: {
    label: "Expired",
    className:
      "border-slate-200 bg-slate-100 text-slate-600",
  },
  REVOKED: {
    label: "Revoked",
    className:
      "border-rose-200 bg-rose-50 text-rose-700",
  },
  ACCEPTED: {
    label: "Accepted",
    className:
      "border-emerald-200 bg-emerald-50 text-emerald-700",
  },
  FAILED: {
    label: "Failed",
    className:
      "border-rose-200 bg-rose-50 text-rose-700",
  },
  RUNNING: {
    label: "Running",
    className:
      "border-sky-200 bg-sky-50 text-sky-700",
  },
  COMPLETED: {
    label: "Completed",
    className:
      "border-emerald-200 bg-emerald-50 text-emerald-700",
  },
  CANCELLED: {
    label: "Cancelled",
    className:
      "border-slate-200 bg-slate-100 text-slate-600",
  },
};

export function PlatformStatusBadge({
  status,
}: PlatformStatusBadgeProps) {
  const configuration = statusStyles[status];

  return (
    <span
      className={[
        "inline-flex shrink-0 items-center rounded-full border px-2.5 py-1 text-xs font-semibold",
        configuration.className,
      ].join(" ")}
    >
      {configuration.label}
    </span>
  );
}